import styled from 'styled-components';

export const ShareBarShareCTAWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  padding: 4px 8px;
  cursor: pointer;

  position: relative;
`;

export const ShareBarShareCTAText = styled.span`
  font-weight: 500;
  font-size: 14px;
  font-style: normal;
  line-height: normal;

  color: var(--color-text);

  text-align: center;
`;

interface ShareBarShareCTACopiedMessageContainerProps {
  top: number;
  left: number;
}

export const ShareBarShareCTACopiedMessageContainer = styled.div<ShareBarShareCTACopiedMessageContainerProps>`
  position: absolute;
  ${({ top, left }) => `
    left: ${left}px;
    top: ${top}px;
  `}
  padding: 8px 12px;

  color: #fff;
  font-size: 14px;
  line-height: 18px;

  border-radius: 5px;
  background: var(--color-text);

  z-index: 99999999;
`;
